import { Sizes } from "../constants/size";
import type { IconProps } from "../types/icon-props";

export const Pedal = (props: IconProps) => {
  const {
    size = "md",
    fill = "var(--grey-1)",
    stroke = "var(--grey-1)",
    ...rest
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 33 20"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#clip0_9950_263)">
        <path
          d="M29.0108 0.43457L15.9663 12.1778L11.0259 16.635H0.599609L5.81275 11.9362L10.7609 7.48672L18.5845 0.43457H29.0108Z"
          fill="#F88C00"
        />
        <path
          d="M32.3307 19.565H22.4421L15.1094 12.957H24.998L32.3307 19.565Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_9950_263">
          <rect
            width="31.7308"
            height="19.1304"
            fill="white"
            transform="translate(0.599609 0.43457)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

Pedal.displayName = "Pedal";
